import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "newplan" }
const _hoisted_2 = { class: "newplan__head" }
const _hoisted_3 = { class: "newplan__head__back" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Comprar un nuevo plan", -1)
const _hoisted_6 = { class: "newplan__body" }
const _hoisted_7 = { class: "newplan__body__steps" }
const _hoisted_8 = { class: "newplan__body__steps__head" }
const _hoisted_9 = { class: "steps" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "newplan__body__steps__body"
}
const _hoisted_12 = { class: "saves-card" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "saves-card__title mt-3" }, "¿Cuánto deseas ahorrar al mes?", -1)
const _hoisted_14 = { class: "saves-card__slider" }
const _hoisted_15 = { class: "min" }
const _hoisted_16 = { class: "max" }
const _hoisted_17 = {
  key: 0,
  class: "saves-card__savings"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "saves-card__savings__title mb-4" }, "¿Por cuántos años deseas ahorrar?", -1)
const _hoisted_19 = { class: "saves-card__savings__years" }
const _hoisted_20 = ["id", "value", "onUpdate:modelValue", "onChange"]
const _hoisted_21 = ["for"]
const _hoisted_22 = {
  key: 1,
  class: "saves-card__savings__loader"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Cargando planes", -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, " No hemos encontrado un plan para ti ", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "saves-card__annual visible-mobile" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col" }
const _hoisted_32 = { class: "box" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Mi aporte total", -1)
const _hoisted_34 = { class: "col" }
const _hoisted_35 = { class: "box" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "Mi ganancia", -1)
const _hoisted_37 = { class: "col" }
const _hoisted_38 = { class: "box" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "Devolución total", -1)
const _hoisted_40 = { class: "box-b" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mi tasa de interés anual:")
], -1)
const _hoisted_43 = { class: "col-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, "(TEA Referencial)", -1)
const _hoisted_45 = { class: "visible-mobile" }
const _hoisted_46 = { class: "d-flex justify-content-center" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "step-space hidden-mobile" }, null, -1)
const _hoisted_48 = {
  key: 0,
  class: "summary-card hidden-mobile"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "summary-card__title" }, "Mi plan", -1)
const _hoisted_50 = { class: "summary-card__data" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mi aporte total")
], -1)
const _hoisted_53 = { class: "col-sm" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mi ganancia")
], -1)
const _hoisted_56 = { class: "col-sm" }
const _hoisted_57 = { class: "row" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Devolución total")
], -1)
const _hoisted_59 = { class: "col-sm" }
const _hoisted_60 = { class: "summary-card__interest" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Mi tasa de"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" interés anual es:")
  ])
], -1)
const _hoisted_63 = { class: "col-sm" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Aprovecha esta SUPER tasa "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ahorrando DE A POCOS cada mes")
  ])
], -1)
const _hoisted_65 = { class: "d-flex justify-content-center" }
const _hoisted_66 = { class: "quote" }
const _hoisted_67 = {
  key: 0,
  class: "quote__step mt-3 mb-4"
}
const _hoisted_68 = { class: "payment-step" }
const _hoisted_69 = { class: "row justify-content-center" }
const _hoisted_70 = { class: "col-md-12 col-sm-12 col-12 px-0" }
const _hoisted_71 = { action: "" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "visible-mobile col-md-6 col-12" }
const _hoisted_74 = { class: "summary shadow-sm" }
const _hoisted_75 = { class: "summary__section" }
const _hoisted_76 = { class: "summary__section__label text-main mb-2 text-left" }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-down",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_79 = [
  _hoisted_78
]
const _hoisted_80 = { key: 1 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-up",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { class: "summary__section__detail" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("span", null, "Pago mensual:", -1)
const _hoisted_86 = { class: "summary__section__detail" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", null, "Período:", -1)
const _hoisted_88 = { key: 1 }
const _hoisted_89 = { class: "summary__section__detail" }
const _hoisted_90 = { class: "row w-100" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Pago mensual:")
], -1)
const _hoisted_92 = { class: "col-5 pe-0" }
const _hoisted_93 = { class: "d-block" }
const _hoisted_94 = { class: "summary__section__detail" }
const _hoisted_95 = { class: "row w-100" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Período:")
], -1)
const _hoisted_97 = { class: "col-5 pe-0" }
const _hoisted_98 = { class: "summary__section__detail" }
const _hoisted_99 = { class: "row w-100" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tu 2da fecha de pago:")
], -1)
const _hoisted_101 = { class: "col-5 pe-0" }
const _hoisted_102 = { class: "summary__section__detail" }
const _hoisted_103 = { class: "row w-100" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ganancia:")
], -1)
const _hoisted_105 = { class: "col-5 pe-0" }
const _hoisted_106 = { class: "summary__section__detail" }
const _hoisted_107 = { class: "row w-100" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Monto de cobertura:")
], -1)
const _hoisted_109 = { class: "col-5 pe-0" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__detail" }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__infouser mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Datos del Titular")
], -1)
const _hoisted_112 = { class: "summary__section__detail" }
const _hoisted_113 = { class: "row w-100" }
const _hoisted_114 = { class: "col-7 text-upper text-uppercase ps-0" }
const _hoisted_115 = { class: "col-5 pe-0" }
const _hoisted_116 = { class: "summary__section__detail" }
const _hoisted_117 = { class: "row w-100" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nombre:")
], -1)
const _hoisted_119 = { class: "col-5 pe-0" }
const _hoisted_120 = { class: "summary__section__detail" }
const _hoisted_121 = { class: "row w-100" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fecha de Nacimiento:")
], -1)
const _hoisted_123 = { class: "col-5 pe-0" }
const _hoisted_124 = { class: "summary__section__detail" }
const _hoisted_125 = { class: "row w-100" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Celular:")
], -1)
const _hoisted_127 = { class: "col-5 pe-0" }
const _hoisted_128 = { class: "summary__section__detail" }
const _hoisted_129 = { class: "row w-100" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 ps-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Correo:")
], -1)
const _hoisted_131 = { class: "col-5 pe-0" }
const _hoisted_132 = /*#__PURE__*/_createStaticVNode("<div class=\"summary__info\"><div class=\"summary__section__detail\"><span class=\"text-center\"> Enviaremos el contrato a tu correo con esta información detallada. </span></div><div class=\"summary__section__detail\"><span class=\"text-center\">Puedes modificar los beneficiarios de tu seguro de vida enviando un correo a <br><a href=\"mailto:rumbo@interseguro.com.pe\">rumbo@interseguro.com.pe</a></span></div></div>", 1)
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "col-md-6 col-12" }
const _hoisted_135 = { class: "paycard card card-form card-1-quote-step-2" }
const _hoisted_136 = { class: "paycard__box card-body" }
const _hoisted_137 = { class: "visible-mobile text-center mt-2" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("span", null, "Aceptamos todas las tarjetas:", -1)
const _hoisted_139 = { class: "payments-cards text-center" }
const _hoisted_140 = { class: "card-brands" }
const _hoisted_141 = ["src"]
const _hoisted_142 = { class: "hidden-mobile" }
const _hoisted_143 = { class: "payments-cards text-center mt-2" }
const _hoisted_144 = /*#__PURE__*/_createElementVNode("span", null, "Aceptamos todas las tarjetas:", -1)
const _hoisted_145 = { class: "card-brands" }
const _hoisted_146 = ["src"]
const _hoisted_147 = { class: "cardpays px-2" }
const _hoisted_148 = { action: "" }
const _hoisted_149 = { class: "form-group card-form mb-0" }
const _hoisted_150 = { class: "row" }
const _hoisted_151 = { class: "form-group" }
const _hoisted_152 = ["src"]
const _hoisted_153 = ["src"]
const _hoisted_154 = ["src"]
const _hoisted_155 = ["src"]
const _hoisted_156 = ["src"]
const _hoisted_157 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el número de tu tarjeta", -1)
const _hoisted_158 = ["src"]
const _hoisted_159 = { class: "form-group" }
const _hoisted_160 = ["src"]
const _hoisted_161 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa una fecha de expiración válida", -1)
const _hoisted_162 = { class: "form-group" }
const _hoisted_163 = ["src"]
const _hoisted_164 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el código CVV", -1)
const _hoisted_165 = { class: "row" }
const _hoisted_166 = { class: "col-12 col-md-6 col-sm-6" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el titular de la tarjeta", -1)
const _hoisted_168 = { class: "col-12 col-md-6 col-sm-6" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu correo electrónico", -1)
const _hoisted_170 = { class: "form-group" }
const _hoisted_171 = { class: "custom-control custom-checkbox" }
const _hoisted_172 = {
  class: "custom-control-label",
  for: "customCheckDisabled2"
}
const _hoisted_173 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_174 = {
  key: 0,
  class: "text-main d-block"
}
const _hoisted_175 = { class: "payment-footer pl-0 pr-0" }
const _hoisted_176 = { class: "visible-mobile" }
const _hoisted_177 = { class: "d-flex justify-content-center" }
const _hoisted_178 = ["disabled"]
const _hoisted_179 = { key: 0 }
const _hoisted_180 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_181 = { class: "hidden-mobile col-md-5 col-12 pl-3 ps-5" }
const _hoisted_182 = { class: "summary card-2-quote-step-2" }
const _hoisted_183 = { class: "summary__section" }
const _hoisted_184 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__label text-main mb-2" }, " Tu resumen de pago ", -1)
const _hoisted_185 = { class: "summary__section__detail" }
const _hoisted_186 = { class: "row" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pago mensual:")
], -1)
const _hoisted_188 = { class: "col pl-0" }
const _hoisted_189 = { class: "summary__section__detail" }
const _hoisted_190 = { class: "row" }
const _hoisted_191 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Período:")
], -1)
const _hoisted_192 = { class: "col pl-0" }
const _hoisted_193 = { class: "summary__section__detail" }
const _hoisted_194 = { class: "row" }
const _hoisted_195 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Tu 2da fecha de pago:")
], -1)
const _hoisted_196 = { class: "col pl-0" }
const _hoisted_197 = { class: "summary__section__detail" }
const _hoisted_198 = { class: "row" }
const _hoisted_199 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ganancia:")
], -1)
const _hoisted_200 = { class: "col pl-0" }
const _hoisted_201 = { class: "summary__section__detail" }
const _hoisted_202 = { class: "row" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Monto de cobertura:")
], -1)
const _hoisted_204 = { class: "col pl-0" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__infouser" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Datos del Titular")
], -1)
const _hoisted_206 = { class: "summary__section__detail" }
const _hoisted_207 = { class: "row" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nombre:")
], -1)
const _hoisted_209 = { class: "col pl-0" }
const _hoisted_210 = { class: "d-block" }
const _hoisted_211 = { class: "summary__section__detail" }
const _hoisted_212 = { class: "row" }
const _hoisted_213 = { class: "col-7 pr-0" }
const _hoisted_214 = { class: "text-upper text-uppercase" }
const _hoisted_215 = { class: "col pl-0" }
const _hoisted_216 = { class: "summary__section__detail" }
const _hoisted_217 = { class: "row" }
const _hoisted_218 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Fecha de Nacimiento:")
], -1)
const _hoisted_219 = { class: "col pl-0" }
const _hoisted_220 = { class: "summary__section__detail" }
const _hoisted_221 = { class: "row" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Celular:")
], -1)
const _hoisted_223 = { class: "col pl-0" }
const _hoisted_224 = { class: "summary__section__detail" }
const _hoisted_225 = { class: "row" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("div", { class: "col-7 pr-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Correo:")
], -1)
const _hoisted_227 = { class: "col-5 pl-0" }
const _hoisted_228 = { class: "summary__info" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__detail" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-text" }, [
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode("Puedes modificar los beneficiarios de tu seguro "),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" de vida enviando un correo a "),
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:rumbo@interseguro.com.pe" }, "rumbo@interseguro.com.pe")
    ])
  ])
], -1)
const _hoisted_230 = { class: "d-flex justify-content-center" }
const _hoisted_231 = ["disabled"]
const _hoisted_232 = { key: 0 }
const _hoisted_233 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_234 = { class: "modal-success__header" }
const _hoisted_235 = /*#__PURE__*/_createElementVNode("div", { class: "modal-success__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Exito")
], -1)
const _hoisted_236 = { class: "modal-success__img" }
const _hoisted_237 = ["src"]
const _hoisted_238 = { class: "modal-success__head" }
const _hoisted_239 = /*#__PURE__*/_createElementVNode("div", { class: "modal-success__head__content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "evaluate" }, "Tu nuevo fondo ha sido creado correctamente."),
  /*#__PURE__*/_createElementVNode("span", { class: "time" }, "Recibirás tu poliza en tu correo electrónico registrado..")
], -1)
const _hoisted_240 = { class: "modal-success__head__btn" }
const _hoisted_241 = { class: "modal-error__header" }
const _hoisted_242 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Error")
], -1)
const _hoisted_243 = { class: "modal-error__img" }
const _hoisted_244 = ["src"]
const _hoisted_245 = { class: "modal-error__head" }
const _hoisted_246 = { key: 0 }
const _hoisted_247 = { key: 1 }
const _hoisted_248 = { class: "modal-error__head__btn" }
const _hoisted_249 = { class: "modal-error__header" }
const _hoisted_250 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Error")
], -1)
const _hoisted_251 = { class: "modal-error__img" }
const _hoisted_252 = ["src"]
const _hoisted_253 = { class: "modal-error__head" }
const _hoisted_254 = /*#__PURE__*/_createElementVNode("span", null, "Por favor ingrese una tarjeta de crédito o débito válida", -1)
const _hoisted_255 = { class: "modal-error__head__btn" }
const _hoisted_256 = { class: "modal-login__form" }
const _hoisted_257 = /*#__PURE__*/_createElementVNode("small", null, "Ingrese un email válido", -1)
const _hoisted_258 = { class: "form-group" }
const _hoisted_259 = ["disabled"]
const _hoisted_260 = { key: 0 }
const _hoisted_261 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_262 = {
  key: 0,
  class: "mt-2 text-success"
}
const _hoisted_263 = {
  key: 0,
  class: "modal-login__form"
}
const _hoisted_264 = { class: "form-group" }
const _hoisted_265 = { class: "btncustom custom-control custom-radio custom-control-inline" }
const _hoisted_266 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "loginDni"
}, "DNI", -1)
const _hoisted_267 = { class: "btncustom custom-control custom-radio custom-control-inline" }
const _hoisted_268 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "loginCe"
}, "CE", -1)
const _hoisted_269 = { class: "text-uppercase" }
const _hoisted_270 = /*#__PURE__*/_createElementVNode("small", null, "Ingrese un número de documento válido", -1)
const _hoisted_271 = { class: "form-group" }
const _hoisted_272 = ["disabled"]
const _hoisted_273 = { key: 0 }
const _hoisted_274 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_275 = {
  key: 1,
  class: "modal-login__form"
}
const _hoisted_276 = { class: "form-group" }
const _hoisted_277 = {
  for: "",
  style: {"color":"#fff","position":"initial"}
}
const _hoisted_278 = /*#__PURE__*/_createElementVNode("label", { class: "text-uppercase" }, "Codigo de autenticación", -1)
const _hoisted_279 = /*#__PURE__*/_createElementVNode("small", null, "Ingrese un código válido", -1)
const _hoisted_280 = { class: "form-group" }
const _hoisted_281 = ["disabled"]
const _hoisted_282 = { key: 0 }
const _hoisted_283 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_284 = { class: "modal-free-month__head" }
const _hoisted_285 = ["src"]
const _hoisted_286 = { class: "modal-free-month__countdown" }
const _hoisted_287 = { class: "time-box" }
const _hoisted_288 = { class: "time-box__time" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Horas", -1)
const _hoisted_290 = { class: "time-box" }
const _hoisted_291 = { class: "time-box__time" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Minutos", -1)
const _hoisted_293 = { class: "time-box" }
const _hoisted_294 = { class: "time-box__time" }
const _hoisted_295 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Segundos", -1)
const _hoisted_296 = { class: "modal-free-month__content" }
const _hoisted_297 = /*#__PURE__*/_createElementVNode("div", { class: "top-title" }, "Te regalamos tu", -1)
const _hoisted_298 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Primer"),
  /*#__PURE__*/_createElementVNode("h2", null, "Mes gratis"),
  /*#__PURE__*/_createElementVNode("p", null, "Ahorra desde S/5 al día y protege a tu familia")
], -1)
const _hoisted_299 = { class: "bullets" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("h4", null, "¿Cómo funciona la cuota gratis?", -1)
const _hoisted_301 = /*#__PURE__*/_createElementVNode("li", { class: "bullets__stepone" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Haz crecer tu dinero "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" gratis desde hoy ")
  ])
], -1)
const _hoisted_302 = /*#__PURE__*/_createElementVNode("li", { class: "bullets__steptwo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Tu familia estará "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" protegida al instante ")
  ])
], -1)
const _hoisted_303 = { class: "bullets__stepthree" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("span", null, "3", -1)
const _hoisted_305 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_306 = ["src"]
const _hoisted_307 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_308 = /*#__PURE__*/_createElementVNode("div", { class: "info" }, " Aplica 1 cuota gratis por cliente para aportes hasta S/400. ", -1)
const _hoisted_309 = { class: "action" }
const _hoisted_310 = { class: "modal-error__header" }
const _hoisted_311 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Error")
], -1)
const _hoisted_312 = { class: "modal-error__img" }
const _hoisted_313 = ["src"]
const _hoisted_314 = { class: "modal-error__head" }
const _hoisted_315 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("No hemos encontrado un plan para las condiciones escogidas. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Cambia el monto a pagar o la frecuencia de pago ")
], -1)
const _hoisted_316 = { class: "modal-error__head__btn" }
const _hoisted_317 = ["src"]
const _hoisted_318 = /*#__PURE__*/_createElementVNode("h3", null, "Tu pago se está procesando", -1)
const _hoisted_319 = /*#__PURE__*/_createElementVNode("h4", null, "Espera unos minutos por favor", -1)
const _hoisted_320 = /*#__PURE__*/_createElementVNode("div", { class: "general-conditions" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Condiciones generales"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Para acceder a las condiciones generales y particulares de la póliza, haz clic en los siguientes enlaces: "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_General.pdf"
    }, "Condicionado General"),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_Particular.pdf"
    }, "Condicionado Particular")
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "Exclusiones"),
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
      /*#__PURE__*/_createElementVNode("p", null, "La cobertura escogida incluye:"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "Fallecimiento por muerte natural.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
      /*#__PURE__*/_createElementVNode("p", null, "La cobertura escogida NO incluye:"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "Fallecimiento por muerte accidental."),
        /*#__PURE__*/_createElementVNode("li", null, "Enfermedades graves."),
        /*#__PURE__*/_createElementVNode("li", null, "Invalidez total y permanente.")
      ])
    ])
  ])
], -1)
const _hoisted_321 = /*#__PURE__*/_createElementVNode("p", null, " Declaro que tengo conocimiento y acepto las Condiciones Generales, Particulares, Especiales y Cláusulas Adicionales relacionadas con la Póliza de Seguros de Interseguro Compañía de Seguros. ", -1)
const _hoisted_322 = /*#__PURE__*/_createElementVNode("p", null, " Certifico que las respuestas y declaraciones realizadas en este sitio web son verídicas y que se ajustan a la realidad y de no serlo, cualquier declaración falsa hecha por el Contratante, voluntaria o involuntariamente, invalida esta solicitud y libera de toda responsabilidad y compromiso indemnizatorio a Interseguro Compañía de Seguros, quedando el seguro emitido en virtud de esta solicitud nulo y sin efecto. ", -1)
const _hoisted_323 = /*#__PURE__*/_createElementVNode("p", null, " El Contratante otorga su consentimiento para que su Póliza de seguro electrónica, endosos futuros, cartas y/u otra documentación, sean enviados vía correo electrónico desde el dominio @interseguro. Todas aquellos documentos y comunicaciones se entenderán por recibidos en la casilla de correo electrónica declarada por el Contratante, a través de la confirmación del servidor de destino. La póliza contendrá una firma digital y una contraseña de acceso para visualizar el documento, ello garantizará la autenticidad e integridad del documento, de acuerdo con lo estipulado en la Ley N° 27269 - Ley de Firmas y Certificados Digitales. Asimismo, declara conocer las medidas de seguridad que debe adoptar para la recepción de los citados documentos, las ventajas y riesgos asociados a esta modalidad de envío, garantiza haber suministrado un correo electrónico válido en la Solicitud de Seguro, el cual mantendrá activo y con espacio suficiente para recibir la Póliza y se comprometen a informar su nuevo correo electrónico, en caso sea dado de baja o desee modificar la cuenta de correo declarada. ", -1)
const _hoisted_324 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Sus datos personales serán utilizados por Interseguro Compañía de Seguros S.A. ("),
  /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO"),
  /*#__PURE__*/_createTextVNode(") para las siguientes finalidades: ")
], -1)
const _hoisted_325 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Para la adquisición de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Enviar documentos de contratación de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Realizar cotizaciones de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO"),
    /*#__PURE__*/_createTextVNode(" por solicitud del USUARIO ")
  ])
], -1)
const _hoisted_326 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Para mayor información puedes consultar la   "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro.pdf",
    target: "_blank",
    class: "text-main",
    style: {"text-decoration":"underline"}
  }, "Política de privacidad")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", null, "Hola " + _toDisplayString(_ctx.showUserName()), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
        }, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/chevron.svg'),
            alt: ""
          }, null, 8, _hoisted_4)
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["steps__step", { current: step.active || step.completed }]),
                onClick: ($event: any) => (_ctx.navigateToStep(step)),
                key: step.key
              }, [
                _createElementVNode("span", null, _toDisplayString(index + 1), 1),
                _createElementVNode("p", null, _toDisplayString(step.label), 1)
              ], 10, _hoisted_10))
            }), 128))
          ])
        ]),
        (!_ctx.flags.paymentCompleted)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.currentStep.key === 'goal')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Slider, {
                          modelValue: this.v$.goal.amount.$model,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.v$.goal.amount.$model) = $event)),
                          step: _ctx.amountSlider.interval,
                          format: { prefix: 'S/ ' },
                          min: _ctx.amountSlider.min,
                          max: _ctx.amountSlider.max,
                          orientation: 'horizontal',
                          onChange: _ctx.changeAmount
                        }, null, 8, ["modelValue", "step", "min", "max", "onChange"]),
                        _createElementVNode("span", _hoisted_15, "S/ " + _toDisplayString(_ctx.amountSlider.min), 1),
                        _createElementVNode("span", _hoisted_16, "S/ " + _toDisplayString(_ctx.amountSlider.max), 1)
                      ]),
                      (!_ctx.flags.loadingPlans)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _hoisted_18,
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "form-group",
                                  key: option.id
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: 'year-' + index,
                                    value: option.id,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.goal.option) = $event),
                                    onChange: ($event: any) => (_ctx.changeOption(option)),
                                    name: "saving-years",
                                    type: "radio"
                                  }, null, 40, _hoisted_20), [
                                    [_vModelRadio, _ctx.goal.option]
                                  ]),
                                  _createElementVNode("label", {
                                    for: 'year-' + index
                                  }, _toDisplayString(option.duration) + " años", 9, _hoisted_21)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.flags.loadingPlans)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                        : _createCommentVNode("", true),
                      (_ctx.allOptions.length === 0 && !_ctx.flags.loadingPlans)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1),
                              _hoisted_33
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1),
                              _hoisted_36
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1),
                              _hoisted_39
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.selectedOption.tea) + "%", 1),
                              _hoisted_44
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("button", {
                            class: "saves-card__annual__btn",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOption(_ctx.selectedOption)))
                          }, " Continuar ")
                        ])
                      ])
                    ]),
                    _hoisted_47,
                    (_ctx.selectedOption)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("ul", _hoisted_50, [
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_51, [
                                _hoisted_52,
                                _createElementVNode("div", _hoisted_53, [
                                  _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_54, [
                                _hoisted_55,
                                _createElementVNode("div", _hoisted_56, [
                                  _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("li", null, [
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("div", _hoisted_59, [
                                  _createElementVNode("p", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.amount)), 1)
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.selectedOption.tea) + "%", 1)
                              ]),
                              _hoisted_64
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("button", {
                              class: "summary-card__btn",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setOption(_ctx.selectedOption)))
                            }, " Continuar ")
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_66, [
        (_ctx.currentStep.key === 'payment')
          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("form", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("div", _hoisted_75, [
                              _createElementVNode("div", _hoisted_76, [
                                _createTextVNode(" Tu resumen de pago "),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.awesome = !_ctx.awesome))
                                }, [
                                  (_ctx.awesome)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_77, _hoisted_79))
                                    : _createCommentVNode("", true),
                                  (!_ctx.awesome)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_80, _hoisted_82))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.awesome)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                    _createElementVNode("div", _hoisted_84, [
                                      _hoisted_85,
                                      _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.amount)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _hoisted_87,
                                      _createElementVNode("b", null, _toDisplayString(_ctx.selectedOption.duration) + " años", 1)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                      _createElementVNode("div", _hoisted_90, [
                                        _hoisted_91,
                                        _createElementVNode("div", _hoisted_92, [
                                          _createElementVNode("b", _hoisted_93, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.amount)), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_94, [
                                      _createElementVNode("div", _hoisted_95, [
                                        _hoisted_96,
                                        _createElementVNode("div", _hoisted_97, [
                                          _createElementVNode("b", null, _toDisplayString(_ctx.selectedOption.duration) + " años", 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_98, [
                                      _createElementVNode("div", _hoisted_99, [
                                        _hoisted_100,
                                        _createElementVNode("div", _hoisted_101, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.nextPaymentDate), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_102, [
                                      _createElementVNode("div", _hoisted_103, [
                                        _hoisted_104,
                                        _createElementVNode("div", _hoisted_105, [
                                          _createElementVNode("span", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_106, [
                                      _createElementVNode("div", _hoisted_107, [
                                        _hoisted_108,
                                        _createElementVNode("div", _hoisted_109, [
                                          _createElementVNode("span", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.coverage)), 1)
                                        ])
                                      ])
                                    ]),
                                    _hoisted_110,
                                    _hoisted_111,
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", _hoisted_113, [
                                        _createElementVNode("div", _hoisted_114, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.identificationType) + ":", 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_115, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.identificationNumber), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_116, [
                                      _createElementVNode("div", _hoisted_117, [
                                        _hoisted_118,
                                        _createElementVNode("div", _hoisted_119, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.firstName), 1),
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.lastName) + " " + _toDisplayString(_ctx.userInfo.secondLastName), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_120, [
                                      _createElementVNode("div", _hoisted_121, [
                                        _hoisted_122,
                                        _createElementVNode("div", _hoisted_123, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.inputDob), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_124, [
                                      _createElementVNode("div", _hoisted_125, [
                                        _hoisted_126,
                                        _createElementVNode("div", _hoisted_127, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.phone), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_128, [
                                      _createElementVNode("div", _hoisted_129, [
                                        _hoisted_130,
                                        _createElementVNode("div", _hoisted_131, [
                                          _createElementVNode("span", null, [
                                            _createElementVNode("a", null, _toDisplayString(_ctx.userInfo.email), 1)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _hoisted_132
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("div", _hoisted_134, [
                  _createElementVNode("div", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("div", _hoisted_137, [
                        _hoisted_138,
                        _createElementVNode("div", _hoisted_139, [
                          _createElementVNode("div", _hoisted_140, [
                            _createElementVNode("img", {
                              src: require('@/assets/images/app/card-brands.png'),
                              alt: "",
                              class: "input-icon-left w-100"
                            }, null, 8, _hoisted_141)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_142, [
                        _createElementVNode("div", _hoisted_143, [
                          _hoisted_144,
                          _createElementVNode("div", _hoisted_145, [
                            _createElementVNode("img", {
                              src: require('@/assets/images/app/card-brands.png'),
                              alt: "",
                              class: "input-icon-left"
                            }, null, 8, _hoisted_146)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("form", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _createElementVNode("div", _hoisted_150, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["col-md-12 col-sm-12 col-12", {
                                                        invalid: this.v$.payment.creditCardNumber.$error,
                                                    }])
                              }, [
                                _createElementVNode("div", _hoisted_151, [
                                  (_ctx.payment.creditCardType === '')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: 
                                                                require('@/assets/images/app/Trazado14308.svg')
                                                            ,
                                        alt: "",
                                        class: "input-icon-left"
                                      }, null, 8, _hoisted_152))
                                    : _createCommentVNode("", true),
                                  (_ctx.payment.creditCardType === 'VISA')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: require('@/assets/images/app/visa.svg'),
                                        alt: "",
                                        class: "input-card"
                                      }, null, 8, _hoisted_153))
                                    : _createCommentVNode("", true),
                                  (_ctx.payment.creditCardType === 'MASTERCARD')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 2,
                                        src: require('@/assets/images/app/mc.svg'),
                                        alt: "",
                                        class: "input-card"
                                      }, null, 8, _hoisted_154))
                                    : _createCommentVNode("", true),
                                  (_ctx.payment.creditCardType === 'DINERS')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 3,
                                        src: require('@/assets/images/app/diners.svg'),
                                        alt: "",
                                        class: "input-card"
                                      }, null, 8, _hoisted_155))
                                    : _createCommentVNode("", true),
                                  (_ctx.payment.creditCardType === 'AMEX')
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 4,
                                        src: require('@/assets/images/app/amex.svg'),
                                        alt: "",
                                        class: "input-card"
                                      }, null, 8, _hoisted_156))
                                    : _createCommentVNode("", true),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control cc-input",
                                    placeholder: "Número de tarjeta",
                                    "data-culqi": "card[number]",
                                    id: "card[number]",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((
                                                                    this.v$.payment.creditCardNumber.$model
                                                                ) = $event)),
                                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateCreditCard())),
                                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.savePaymentEvent()))
                                  }, null, 544), [
                                    [_directive_mask, '#### #### #### ####'],
                                    [_vModelText, 
                                                                    this.v$.payment.creditCardNumber.$model
                                                                ]
                                  ]),
                                  _hoisted_157,
                                  (_ctx.payment.validCard)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 5,
                                        src: 
                                                                require('@/assets/images/app/check-color.svg')
                                                            ,
                                        class: "valid-card-icon",
                                        alt: ""
                                      }, null, 8, _hoisted_158))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["col-md-6 col-sm-6 col-6", {
                                                        invalid:
                                                            this.v$.payment.expirationDate.$error ||
                                                            this.flags.invalidExpirationDate,
                                                    }])
                              }, [
                                _createElementVNode("div", _hoisted_159, [
                                  _createElementVNode("img", {
                                    src: require('@/assets/images/app/img1.svg'),
                                    alt: "",
                                    class: "input-icon-left"
                                  }, null, 8, _hoisted_160),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "MM/AA",
                                    maxlength: "5",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((this.v$.payment.expirationDate.$model) = $event)),
                                    onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setExpirationDate())),
                                    onKeydown: _cache[10] || (_cache[10] = ($event: any) => (_ctx.validateInput($event, /^\d+$/)))
                                  }, null, 544), [
                                    [_vModelText, this.v$.payment.expirationDate.$model],
                                    [_directive_mask, '##/##']
                                  ]),
                                  _hoisted_161,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "hidden",
                                    size: "2",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((this.v$.payment.month.$model) = $event)),
                                    "data-culqi": "card[exp_month]",
                                    id: "card[exp_month]"
                                  }, null, 512), [
                                    [_vModelText, this.v$.payment.month.$model]
                                  ]),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "hidden",
                                    size: "4",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.v$.payment.year.$model) = $event)),
                                    "data-culqi": "card[exp_year]",
                                    id: "card[exp_year]"
                                  }, null, 512), [
                                    [_vModelText, this.v$.payment.year.$model]
                                  ])
                                ])
                              ], 2),
                              _createElementVNode("div", {
                                class: _normalizeClass(["col-md-6 col-sm-6 col-6", {
                                                        invalid: this.v$.payment.maskedCvv.$error,
                                                    }])
                              }, [
                                _createElementVNode("div", _hoisted_162, [
                                  _createElementVNode("img", {
                                    src: require('@/assets/images/app/lock.svg'),
                                    alt: "",
                                    class: "input-icon-left"
                                  }, null, 8, _hoisted_163),
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "CVV",
                                    maxlength: "4",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((this.v$.payment.maskedCvv.$model) = $event)),
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => {
    _ctx.maskCvv();
_ctx.savePaymentEvent();
                                                                }),
                                    onKeydown: _cache[15] || (_cache[15] = ($event: any) => (_ctx.validateInput($event, /^\d+$/)))
                                  }, null, 544), [
                                    [_vModelText, this.v$.payment.maskedCvv.$model]
                                  ]),
                                  _hoisted_164,
                                  _withDirectives(_createElementVNode("input", {
                                    type: "hidden",
                                    size: "4",
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((this.v$.payment.cvv.$model) = $event)),
                                    "data-culqi": "card[cvv]",
                                    id: "card[cvv]"
                                  }, null, 512), [
                                    [_vModelText, this.v$.payment.cvv.$model]
                                  ])
                                ])
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_165, [
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["form-paymenth form-group", {
                                                        invalid: this.v$.payment.placeholder.$error,
                                                    }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"padding-left":"15px"},
                                  type: "text",
                                  class: "form-control",
                                  placeholder: "Nombre",
                                  onKeydown: _cache[17] || (_cache[17] = ($event: any) => (
                                                                _ctx.validateInput(
                                                                    $event,
                                                                    /^[ñA-Za-z _\s]*[ñA-Za-z\s][ñA-Za-z _\s]*$/
                                                                )
                                                            )),
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((this.v$.payment.placeholder.$model) = $event))
                                }, null, 544), [
                                  [_vModelText, this.v$.payment.placeholder.$model]
                                ]),
                                _hoisted_167,
                                _withDirectives(_createElementVNode("input", {
                                  type: "hidden",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((this.v$.payment.email.$model) = $event)),
                                  "data-culqi": "card[email]",
                                  id: "card[email]"
                                }, null, 512), [
                                  [_vModelText, this.v$.payment.email.$model]
                                ])
                              ], 2)
                            ]),
                            _createElementVNode("div", _hoisted_168, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["form-group", { invalid: this.v$.payment.email.$error }])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  style: {"padding-left":"15px"},
                                  type: "text",
                                  placeholder: "Correo electrónico",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((this.v$.payment.email.$model) = $event)),
                                  "data-culqi": "card[email]",
                                  id: "card[email]"
                                }, null, 512), [
                                  [_vModelText, this.v$.payment.email.$model]
                                ]),
                                _hoisted_169
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_170, [
                            _createElementVNode("div", _hoisted_171, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                class: "custom-control-input",
                                id: "customCheckDisabled2",
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.automaticDebit) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.automaticDebit]
                              ]),
                              _createElementVNode("label", _hoisted_172, [
                                _createTextVNode(" Deseo afiliarme al débito automático "),
                                _hoisted_173,
                                (!_ctx.automaticDebit)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_174, "¿Estás seguro? ¡Los clientes que usan afiliación automática llegan a sus objetivos de ahorro 3 veces más rápido!"))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("div", _hoisted_176, [
                            _createElementVNode("div", _hoisted_177, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "paycard__box__btn",
                                onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.placeOrder())),
                                disabled: _ctx.flags.paying
                              }, [
                                (!_ctx.flags.paying)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_179, "Pagar"))
                                  : _createCommentVNode("", true),
                                (_ctx.flags.paying)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_180))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_178)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("div", _hoisted_182, [
                    _createElementVNode("div", _hoisted_183, [
                      _hoisted_184,
                      _createElementVNode("div", _hoisted_185, [
                        _createElementVNode("div", _hoisted_186, [
                          _hoisted_187,
                          _createElementVNode("div", _hoisted_188, [
                            _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.amount)), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_189, [
                        _createElementVNode("div", _hoisted_190, [
                          _hoisted_191,
                          _createElementVNode("div", _hoisted_192, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.selectedOption.duration) + " años", 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_193, [
                        _createElementVNode("div", _hoisted_194, [
                          _hoisted_195,
                          _createElementVNode("div", _hoisted_196, _toDisplayString(_ctx.nextPaymentDate), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_197, [
                        _createElementVNode("div", _hoisted_198, [
                          _hoisted_199,
                          _createElementVNode("div", _hoisted_200, " S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_201, [
                        _createElementVNode("div", _hoisted_202, [
                          _hoisted_203,
                          _createElementVNode("div", _hoisted_204, " S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.coverage)), 1)
                        ])
                      ]),
                      _hoisted_205,
                      _createElementVNode("div", _hoisted_206, [
                        _createElementVNode("div", _hoisted_207, [
                          _hoisted_208,
                          _createElementVNode("div", _hoisted_209, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.firstName), 1),
                            _createElementVNode("span", _hoisted_210, _toDisplayString(_ctx.userInfo.lastName) + " " + _toDisplayString(_ctx.userInfo.secondLastName), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_211, [
                        _createElementVNode("div", _hoisted_212, [
                          _createElementVNode("div", _hoisted_213, [
                            _createElementVNode("span", _hoisted_214, _toDisplayString(_ctx.userInfo.identificationType) + ":", 1)
                          ]),
                          _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.userInfo.identificationNumber), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_216, [
                        _createElementVNode("div", _hoisted_217, [
                          _hoisted_218,
                          _createElementVNode("div", _hoisted_219, _toDisplayString(_ctx.userInfo.inputDob), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_220, [
                        _createElementVNode("div", _hoisted_221, [
                          _hoisted_222,
                          _createElementVNode("div", _hoisted_223, _toDisplayString(this.userInfo.phone), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_224, [
                        _createElementVNode("div", _hoisted_225, [
                          _hoisted_226,
                          _createElementVNode("div", _hoisted_227, [
                            _createElementVNode("span", null, [
                              _createElementVNode("a", null, _toDisplayString(_ctx.userInfo.email), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_228, [
                        _hoisted_229,
                        _createElementVNode("div", _hoisted_230, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "summary__section__btn",
                            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.placeOrder())),
                            disabled: _ctx.flags.paying
                          }, [
                            (!_ctx.flags.paying)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_232, "Pagar"))
                              : _createCommentVNode("", true),
                            (_ctx.flags.paying)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_233))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_231)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-success",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-success",
      ref: "modal-success"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_234, [
          _hoisted_235,
          _createElementVNode("div", _hoisted_236, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/checks.svg'),
              alt: ""
            }, null, 8, _hoisted_237)
          ])
        ]),
        _createElementVNode("div", _hoisted_238, [
          _hoisted_239,
          _createElementVNode("div", _hoisted_240, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.closeModal('modal-success')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_241, [
          _hoisted_242,
          _createElementVNode("div", _hoisted_243, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_244)
          ])
        ]),
        _createElementVNode("div", _hoisted_245, [
          (_ctx.errors.payment === '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_246, " Se ha presentado un error en nuestro sistema. Intenta nuevamente o escríbenos a correo rumbo@interseguro.com.pe "))
            : _createCommentVNode("", true),
          (_ctx.errors.payment !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_247, _toDisplayString(_ctx.errors.payment), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_248, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.closeModal('modal-error')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-card-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_249, [
          _hoisted_250,
          _createElementVNode("div", _hoisted_251, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_252)
          ])
        ]),
        _createElementVNode("div", _hoisted_253, [
          _hoisted_254,
          _createElementVNode("div", _hoisted_255, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.closeModal('modal-card-error')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-quote",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Enviar cotización",
      ref: "modal-quote"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_256, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", {
                    invalid: this.v$.quote.email.$error,
                }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Ingrese su Email",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((this.v$.quote.email.$model) = $event))
            }, null, 512), [
              [_vModelText, this.v$.quote.email.$model]
            ]),
            _hoisted_257
          ], 2),
          _createElementVNode("div", _hoisted_258, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.sendQuote())),
              type: "button",
              disabled: _ctx.flags.sendingQuote
            }, [
              (!_ctx.flags.sendingQuote)
                ? (_openBlock(), _createElementBlock("span", _hoisted_260, "Enviar cotización"))
                : _createCommentVNode("", true),
              (_ctx.flags.sendingQuote)
                ? (_openBlock(), _createElementBlock("i", _hoisted_261))
                : _createCommentVNode("", true)
            ], 8, _hoisted_259)
          ]),
          (this.flags.sendedQuote)
            ? (_openBlock(), _createElementBlock("p", _hoisted_262, " Cotización enviada, por favor revisa tu correo. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-login",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Inicia sesión"
    }, {
      default: _withCtx(() => [
        (!_ctx.flags.validateOtp)
          ? (_openBlock(), _createElementBlock("form", _hoisted_263, [
              _createElementVNode("div", _hoisted_264, [
                _createElementVNode("div", _hoisted_265, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "loginDni",
                    name: "customRadioInline1",
                    class: "custom-control-input",
                    value: "dni",
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((this.v$.login.identificationType.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, this.v$.login.identificationType.$model]
                  ]),
                  _hoisted_266
                ]),
                _createElementVNode("div", _hoisted_267, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    id: "loginCe",
                    name: "customRadioInline1",
                    class: "custom-control-input",
                    value: "ce",
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((this.v$.login.identificationType.$model) = $event))
                  }, null, 512), [
                    [_vModelRadio, this.v$.login.identificationType.$model]
                  ]),
                  _hoisted_268
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-group", {
                    invalid: this.v$.login.identificationNumber.$error,
                }])
              }, [
                _createElementVNode("label", _hoisted_269, _toDisplayString(_ctx.login.identificationType), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((this.v$.login.identificationNumber.$model) = $event))
                }, null, 512), [
                  [_vModelText, this.v$.login.identificationNumber.$model]
                ]),
                _hoisted_270
              ], 2),
              _createElementVNode("div", _hoisted_271, [
                _createElementVNode("button", {
                  class: "btn btn-second",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.sendOtp())),
                  type: "button",
                  disabled: _ctx.flags.logingIn
                }, [
                  (!_ctx.flags.logingIn)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_273, "Ingresar"))
                    : _createCommentVNode("", true),
                  (_ctx.flags.logingIn)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_274))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_272)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.flags.validateOtp)
          ? (_openBlock(), _createElementBlock("form", _hoisted_275, [
              _createElementVNode("div", _hoisted_276, [
                _createElementVNode("label", _hoisted_277, "Ingresa el código enviado al correo " + _toDisplayString(_ctx.otp.email), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["form-group", {
                    invalid: this.v$.login.identificationNumber.$error,
                }])
              }, [
                _hoisted_278,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((this.v$.otpCode.code.$model) = $event))
                }, null, 512), [
                  [_vModelText, this.v$.otpCode.code.$model]
                ]),
                _hoisted_279
              ], 2),
              _createElementVNode("div", _hoisted_280, [
                _createElementVNode("button", {
                  class: "btn btn-second",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.validateOtp())),
                  type: "button",
                  disabled: _ctx.flags.logingIn
                }, [
                  (!_ctx.flags.logingIn)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_282, "Validar"))
                    : _createCommentVNode("", true),
                  (_ctx.flags.logingIn)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_283))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_281)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-free-month",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "lg",
      "modal-class": "modal-free-month",
      ref: "modal-free-month"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_284, [
          _createTextVNode(" ¡Tenemos un "),
          _createElementVNode("img", {
            src: require('@/assets/images/app/gift.svg'),
            alt: ""
          }, null, 8, _hoisted_285),
          _createTextVNode(" para ti! ")
        ]),
        _createElementVNode("div", _hoisted_286, [
          _createElementVNode("div", _hoisted_287, [
            _createElementVNode("div", _hoisted_288, _toDisplayString(_ctx.hours), 1),
            _hoisted_289
          ]),
          _createElementVNode("div", _hoisted_290, [
            _createElementVNode("div", _hoisted_291, _toDisplayString(_ctx.minutes), 1),
            _hoisted_292
          ]),
          _createElementVNode("div", _hoisted_293, [
            _createElementVNode("div", _hoisted_294, _toDisplayString(_ctx.seconds < 10 ? "0" + _ctx.seconds : _ctx.seconds), 1),
            _hoisted_295
          ])
        ]),
        _createElementVNode("div", _hoisted_296, [
          _hoisted_297,
          _hoisted_298,
          _createElementVNode("div", _hoisted_299, [
            _hoisted_300,
            _createElementVNode("ul", null, [
              _hoisted_301,
              _hoisted_302,
              _createElementVNode("li", _hoisted_303, [
                _hoisted_304,
                _createElementVNode("p", null, [
                  _createTextVNode(" Realiza tu pago "),
                  _hoisted_305,
                  _createTextVNode(" y comunícate a nuestro "),
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/wapp-chat.svg'),
                    alt: ""
                  }, null, 8, _hoisted_306),
                  _hoisted_307,
                  _createTextVNode(" para la devolución ")
                ])
              ])
            ])
          ]),
          _hoisted_308,
          _createElementVNode("div", _hoisted_309, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.closeFreeMonthModal && _ctx.closeFreeMonthModal(...args)))
            }, " Continuar ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-no-plans"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_310, [
          _hoisted_311,
          _createElementVNode("div", _hoisted_312, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_313)
          ])
        ]),
        _createElementVNode("div", _hoisted_314, [
          _hoisted_315,
          _createElementVNode("div", _hoisted_316, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.closeModal('modal-no-plans')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-loading",
      centered: "",
      "hide-backdrop": "",
      size: "sm",
      "modal-class": "modal-loading",
      ref: "modal-loading"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: require('@/assets/images/app/clock.gif'),
          alt: ""
        }, null, 8, _hoisted_317),
        _hoisted_318,
        _hoisted_319
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-conditions",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      "modal-class": "modal-conditions",
      title: " "
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_320
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-terms",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      title: "Declaración jurada del contratante"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_321,
            _hoisted_322,
            _hoisted_323
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-policies",
      "ok-only": "",
      "ok-title": "Cerrar",
      centered: "",
      size: "lg",
      title: "POLÍTICA DE PRIVACIDAD"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_324,
            _hoisted_325,
            _hoisted_326
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}